import { createContext } from 'react';

const CateringDashboardContext = createContext();
CateringDashboardContext.displayName = 'CateringDashboardContext';

export default CateringDashboardContext;
